import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { authentication, host } from '../../api/ApiCalls';
import Button from '../../components/ui/Button';
import { tostifyOption } from '../../utils/toastOptions';

const VerifyOTP = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || '';
  const image = location.state?.image || '';
  const username = location.state?.username || '';
  const degreeImage = location.state?.degreeImage || '';
  const interests = location.state?.interests || [];
  const userData = location.state || {};
  const effectRan = useRef(false); // Prevent useEffect from running twice
  const [verifyOtpLoading, setVerifyOtpLoading] = useState(false);
const [resendOtpLoading, setResendOtpLoading] = useState(false);
const [resendTimer, setResendTimer] = useState(0); // seconds

useEffect(() => {
  let interval;
  if (resendTimer > 0) {
    interval = setInterval(() => {
      setResendTimer((prev) => prev - 1);
    }, 1000);
  }
  return () => clearInterval(interval);
}, [resendTimer]);


  useEffect(() => {
    if (effectRan.current) return; // Prevent double execution

    if (!userData.email) {
      toast.error('Invalid access!', tostifyOption);
      navigate('/signup');
      return;
    }

    handleSendOTP();
    effectRan.current = true; // Mark effect as run
  }, [userData.email, navigate]);

  const [otp, setOtp] = useState('');

  const handleSendOTP = async () => {
    try {
      setResendOtpLoading(true);
      console.log(`${host}/api/otp/send-otp`);
      const res = await axios.post(`${host}/api/otp/send-otp`, { email });
      if (res.status === 200) {
        toast.success('OTP Sent Successfully!', tostifyOption);
      } else {
        toast.error(res.data.message, tostifyOption);
      }
      setResendTimer(60);
      setResendOtpLoading(false);
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'Failed to send OTP',
        tostifyOption
      );
      setResendOtpLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    setVerifyOtpLoading(true);
    try {
      const res = await axios.post(`${host}/api/otp/verify-otp`, {
        email: email.trim(),
        otp: otp.trim(),
      });

      if (res.status === 200) {
        const formDataImage = new FormData();
        formDataImage.append('image', image);

        const imageUploadRes = await axios.post(
          `${host}/api/upload/upload`,
          formDataImage,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );

        let degreeImageUploadRes = { data: { url: '' } }; // Default value in case no degree image is provided

        if (degreeImage) {
          const formDataDegree = new FormData();
          formDataDegree.append('image', degreeImage);

          degreeImageUploadRes = await axios.post(
            `${host}/api/upload/upload`,
            formDataDegree,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
        }

        const registerRes = await axios.post(
          `${host}/${authentication}/register`,
          {
            name: userData.name,
            username: userData.username,
            email: userData.email,
            password: userData.password,
            role: userData.role,
            avatar: imageUploadRes.data.url,
            degreeImage: degreeImageUploadRes.data.url,
            interests: interests,
          }
        );

        toast.success(
          `OTP Verified & ${userData.role} registered successfully`,
          tostifyOption
        );
        navigate('/login');
      } else {
        toast.error(res.data.message || 'Verification failed', tostifyOption);
      }
      setVerifyOtpLoading(false);
    } catch (error) {
      toast.error(
        error.response?.data?.message || 'Invalid OTP, please try again.',
        tostifyOption
      );
    }
    setVerifyOtpLoading(false);
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center">
      <h2 className="text-2xl font-bold mb-4">OTP Verification</h2>
      <p className="text-gray-600 mb-2">
        Enter the OTP sent to <strong>{email}</strong>
      </p>
      <input
        type="text"
        placeholder="Enter OTP"
        className="border p-2 rounded-md mb-4"
        value={otp}
        onChange={(e) => setOtp(e.target.value.replace(/\D/, ''))} // Only allow numbers
        maxLength="6"
      />
      <Button onClick={handleVerifyOTP} disabled={verifyOtpLoading}>
        {verifyOtpLoading ? (
    <div className="flex items-center justify-center gap-2">
      <svg
        className="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
        ></path>
      </svg>
      Verifying...
    </div>
  ) : (
    "Verify OTP"
  )}
      </Button>
      <Button onClick={handleSendOTP} className="mt-2" disabled={resendOtpLoading || resendTimer > 0}>
        {resendOtpLoading ? (
    <div className="flex items-center justify-center gap-2">
      <svg
        className="animate-spin h-5 w-5 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
        ></path>
      </svg>
      Sending...
    </div>
  ) : resendTimer > 0 ? (
    `Resend OTP in ${resendTimer}s`
  ) : (
    "Resend OTP"
  )}
      </Button>{' '}
      {/* Resend OTP Button */}
    </div>
  );
};

export default VerifyOTP;
